export interface MsmeExportIntentProfile {
  businessDomain?: string;
  manufacturingProfile?: {
    exportActivity?: boolean;
    supplyChainType?: string;
  };
}

/** True after the company has chosen export or India-only. An unanswered profile is not a choice. */
export function hasDeclaredExportActivity(profile: MsmeExportIntentProfile | null | undefined): boolean {
  return typeof profile?.manufacturingProfile?.exportActivity === 'boolean';
}

/** True when the MSME profile indicates goods or services are exported. */
export function hasMsmeExportIntent(profile: MsmeExportIntentProfile | null | undefined): boolean {
  if (!profile) {
    return false;
  }
  if (profile.manufacturingProfile?.exportActivity === true) {
    return true;
  }
  if (profile.businessDomain === 'export_import') {
    return true;
  }
  const supplyChain = String(profile.manufacturingProfile?.supplyChainType || '').toLowerCase();
  return /export|global|international|overseas/.test(supplyChain);
}
